var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.timestampShowFlag)?_c('div',{staticClass:"message-timestamp"},[_vm._v(" "+_vm._s(_setup.timestampShowContent)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }